import { render, staticRenderFns } from "./DeleteAccountView.vue?vue&type=template&id=0809f0ff&scoped=true"
import script from "./DeleteAccountView.vue?vue&type=script&lang=ts"
export * from "./DeleteAccountView.vue?vue&type=script&lang=ts"
import style0 from "./DeleteAccountView.vue?vue&type=style&index=0&id=0809f0ff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0809f0ff",
  null
  
)

export default component.exports